import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';

export const getDashboardStatistics = createAsyncThunk(
    'getDashboardStatistics',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getDashboarddata(config);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getAllProductsThunk = createAsyncThunk(
    'product/getAllProducts',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllProduct(config);
            // console.log("resss", response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


const dashboardSlice = createSlice({
    name: 'samplerequest',
    initialState: {
        dashboard: [],
        refresh: false,
        loading: false,
        products: [],
        page: 1,
        status:""
    },
    reducers: {
        setdashboardProductPage: (state, action) => {
            state.page = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardStatistics.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDashboardStatistics.fulfilled, (state, action) => {
                state.loading = false;
                state.dashboard = action.payload;
            })
            .addCase(getDashboardStatistics.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getAllProductsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllProductsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.products = action.payload;
            })
            .addCase(getAllProductsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

    },
});

export const { setdashboardProductPage} = dashboardSlice.actions
export default dashboardSlice.reducer;

